import {
  ICardMedia,
  IResolvedCardItem,
} from '@/src/utils/collections/cards.mapper';
import { CardVideoItemPlayer } from '@/src/components/cards/CardVideoItem/CardVideoItemPlayer';
import { CardContent } from '@/src/components/cards/CardContent/CardContent';

type IProps = Omit<IResolvedCardItem, 'media' | 'actionType' | 'action'> & {
  media: Extract<ICardMedia, { type: 'video' }>;
};

export const CardVideoItem = ({ title, media, content }: IProps) => {
  return (
    <div className={'mx-auto mt-4 max-w-[391px] space-y-4 px-4'}>
      <CardVideoItemPlayer media={media} />
      <div>
        <div className={'text-lg font-semibold'}>{title}</div>
        <CardContent cardContent={content} />
      </div>
    </div>
  );
};
